import { useEffect, useState } from 'react';
import { dbPromise } from './indexedDB';
import { useSelector } from 'react-redux';

const STORE_NAME = 'invoices';
const CREATE_KEY = 'offline_invoice';
const EDIT_KEY_PREFIX = 'offline_invoice_edit_';

const useOfflineInvoice = (invoiceId = null) => {
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const storageKey = invoiceId ? `${EDIT_KEY_PREFIX}${invoiceId}` : `${CREATE_KEY}_${user.user_id}`;

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);
		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);
		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	const saveInvoice = async (data) => {
		try {
			const db = await dbPromise;
			await db.put(STORE_NAME, data, storageKey);
			return true;
		} catch (error) {
			console.error('Save invoice error:', error);

			return false;
		}
	};

	const getInvoice = async () => {
		try {
			const db = await dbPromise;
			return await db.get(STORE_NAME, storageKey);
		} catch (error) {
			console.error('Get invoice error:', error);

			return null;
		}
	};

	const deleteInvoice = async () => {
		try {
			const db = await dbPromise;

			await db.delete(STORE_NAME, storageKey);

			return true;
		} catch (error) {
			console.error('Delete invoice error:', error);

			return false;
		}
	};

	const isSameAsOriginal = (current, original) => {
		if (!original) return false;
		return JSON.stringify(current) === JSON.stringify(original);
	};

	return {
		saveInvoice,
		getInvoice,
		deleteInvoice,
		isOnline,
		isSameAsOriginal,
	};
};

export default useOfflineInvoice;
